import {
  CREATE_ISSUE_CATEGORY,
  DELETE_ISSUE_CATEGORY,
  EDIT_ISSUE_CATEGORY,
  RECEIVE_ISSUE_CATEGORIES,
  REQUEST_ISSUE_CATEGORY,
} from '@sophocles/entities/IssueCategory/issueCategoryActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_ISSUE_CATEGORIES: // Read
      return state.merge(action.issueCategories);
    case DELETE_ISSUE_CATEGORY: // Delete
      return state.delete(action.issueCategory.toString());
    case EDIT_ISSUE_CATEGORY: // Update
    case CREATE_ISSUE_CATEGORY: // Create
    case REQUEST_ISSUE_CATEGORY:
    default:
      return state;
  }
}

export function issueCategoryReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_ISSUE_CATEGORY:
    case DELETE_ISSUE_CATEGORY:
    case RECEIVE_ISSUE_CATEGORIES:
    case EDIT_ISSUE_CATEGORY:
    case REQUEST_ISSUE_CATEGORY:
      return getState(state, action);
    default:
      return state;
  }
}
